import { Fragment } from 'react';

// material-ui
import { Divider, ListItemAvatar, ListItemButton, ListItemText, Stack, Typography } from '@mui/material';

// project imports
import UserAvatar from './UserAvatar';

// assets
import { getUserProfileFullName } from '../../utils/users';

function UserListOption(props: any) {
  if (!props.user) return <></>;
  return (
    <Fragment>
      <ListItemButton sx={{ pl: 1 }} {...props}>
        <ListItemAvatar>
          <UserAvatar user={props.user} />
        </ListItemAvatar>
        <ListItemText
          primary={
            <Stack component="span" direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
              <Typography
                variant="h5"
                color="inherit"
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                {getUserProfileFullName(props.user)}
              </Typography>
              <Typography component="span" color="primary.main" variant="caption">
                  {props.user.role?.join(' / ')}
              </Typography>
            </Stack>
          }
          secondary={
            <Stack component="span" direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
              <Typography
                variant="caption"
                color="textSecondary"
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                {props.user.company?.legalName ? props.user.company?.legalName : props.user.email}
              </Typography>
              {/*<CheckOutlined style={{ color: true ? theme.palette.grey[400] : theme.palette.primary.main }} />*/}
            </Stack>
          }
        />
      </ListItemButton>
      <Divider />
    </Fragment>
  );
}

export default UserListOption;
